/* global global */

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as donation_mod from '../../donation/init.js';
import * as inject_childinfo from '../../donation/inject_childinfo.js';
import * as global_mod from '../../global/index.js';
import * as tealium from '../../datalayer/tealium.js';
import { PAGE_VARS, PageKind } from '../vars.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'connectingus';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------
function init_pagevars() {
    PAGE_VARS.kind = PageKind.Donation;
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    // Initialize donation module and connectingus module after all global
    // modules
    all_modules.push(donation_mod, inject_childinfo);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
